export const Ignore = [
  {
    SUPABASE_URL: "https://isfbfwecvnympjtiqgup.supabase.co",
    SUPABASE_ANON_KEY:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlzZmJmd2Vjdm55bXBqdGlxZ3VwIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTExOTM2ODYsImV4cCI6MjAwNjc2OTY4Nn0.RXXfuu2z6vqju80q_kqNo8e-gJMxbpIHA-LLi48G_yM",
  },
];
